import { render, staticRenderFns } from "./BattlesBoxElement.vue?vue&type=template&id=74a39da3&scoped=true"
import script from "./BattlesBoxElement.vue?vue&type=script&lang=js"
export * from "./BattlesBoxElement.vue?vue&type=script&lang=js"
import style0 from "./BattlesBoxElement.vue?vue&type=style&index=0&id=74a39da3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a39da3",
  null
  
)

export default component.exports